<template>
  <div class="pc-container">
    <div v-for="(item,index) in data" :key="index">
      <component :is="item.type" :data="item"></component>
    </div>
  </div>
</template>

<script>
import {aboutData} from "@/data";


export default {
  name: 'AboutView',
  data(){
    return {
      data:aboutData
    }
  }
}
</script>
<style lang="scss" scoped></style>
